import React, { Component } from 'react';
import { Icon, Grid, Divider } from 'semantic-ui-react';
import { strings } from '../..';
import { datetimeFormatter, getIconName } from '../../core';
import { Archivio } from '../models';

type ArchivioMobileProps = {
    archivio: Archivio,
    onFileClick: (e: any, data: any) => void
}

export default class ArchivioMobile extends Component<ArchivioMobileProps> {
    render () {
        const { idArchivio, numeroProtocollo, dataProtocollo, fileName, tipoDocumento } = this.props.archivio;
        const icona = getIconName(fileName);
        return (
            <div>
                <Grid>
                    <Grid.Column width='2' verticalAlign='middle' textAlign='center'>
                        <Icon size='big' link name={icona.name} color={icona.color} onClick={this.props.onFileClick} id={idArchivio} />
                    </Grid.Column>
                    <Grid.Column width='14'>
                        <h4>{tipoDocumento}</h4>
                        <Grid>
                            <Grid.Column width='8'>
                                {strings.archivi.dataTable.numeroProtocolloMobile}{' '}
                                <span style={{ fontWeight: 'bold' }}>{numeroProtocollo}</span>
                            </Grid.Column>
                            <Grid.Column width='8'>
                                {strings.archivi.dataTable.dataProtocolloMobile}{' '}
                                <span style={{ fontWeight: 'bold' }}>{datetimeFormatter(dataProtocollo)}</span>
                            </Grid.Column>
                        </Grid> 
                    </Grid.Column>
                </Grid>
                <Divider />
            </div>
        );
    } 
}